import React from 'react';
import PropTypes from 'prop-types';
import {Table} from 'antd';
import {toJS} from 'mobx';
import {observer} from 'mobx-react';

const {Column, ColumnGroup} = Table;

/**
 * 默认翻页器
 */
let default_pagination = {
    showSizeChanger: true,
    onShowSizeChange(page_size) {
        // console.log("onShowSizeChange: ", page_size);
    },
    onChange(next_page) {
        // console.log('next_page: ', next_page);
    },
    defaultCurrent: 1,
    defaultPageSize: 10,
    showTotal: function (total, range) {
        return `总条数：${total} 条 `;
    }
};

/**
 * 生成 Column list
 * @param {Array[Object]} columns
 */
function generateColumns(columns) {
    return columns.map((item, index) => {
        if (Array.isArray(item.children) && item.children.length > 0) {
            let {children, ...res} = item;
            return (
                <ColumnGroup {...res}>
                    {
                        generateColumns(children)
                    }
                </ColumnGroup>
            )
        } else {
            return (
                <Column key={index} {...item}></Column>
            );
        }
    });
}

@observer
class ListTable extends React.Component {
    render() {
        let {data_source, pagination, columns, row_key, ...res} = this.props;
        let table_pagination = Object.assign({}, default_pagination, pagination);
        if (Boolean(pagination) === false) {
            table_pagination = false;
        }

        return (
            <div style={{
                background: '#fff'
            }}>
                <Table
                    style={{
                        // fontSize: '12px'
                    }}
                    {...res}
                    dataSource={toJS(data_source)}
                    rowKey={record => record[row_key] || record.id}
                    pagination={table_pagination}>
                    {
                        generateColumns(columns)
                    }
                </Table>
            </div>
        )
    }
}

ListTable.propTypes = {
    // 数据源
    // data_source: PropTypes.arrayOf(
    //   PropTypes.shape({
    //     title: PropTypes.string,
    //     dataIndex: PropTypes.string.isRequired,
    //     render: PropTypes.func
    //   })
    // ).isRequired,
    // 列定义
    columns: PropTypes.array.isRequired
}

export default ListTable;



// WEBPACK FOOTER //
// ./src/components/ListTable/ListTable.jsx